<template>
  <div class="intro-voz-content">
    <div class="intro-voz-title-content" id="identidade-verbal-voz-introducao" data-search-anchor>
      <h1 class="intro-voz-title">{{ introTitle }}</h1>
      <p class="intro-voz-paragraph">{{ introParagraph }}</p>
    </div>

    <div
      class="intro-voz-card-item"
      :style="{ backgroundImage: `url(${introImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class VozIntroSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get introTitle(): string {
    return this.getElementTitle(1, 0)
  }

  get introParagraph(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

   async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.intro-voz-content {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  max-width: 1032px;  
}

.intro-voz-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  padding-right: 78px;
}

.intro-voz-paragraph {
  margin-top: 47px;
  width: 363px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left; 
} 

.intro-voz-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
}

</style>

